import { render, staticRenderFns } from "./StepAppointment.vue?vue&type=template&id=3ddb2dc2&"
import script from "./StepAppointment.vue?vue&type=script&lang=js&"
export * from "./StepAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports